import { render, staticRenderFns } from "./OrganiserDiscountPrompt.vue?vue&type=template&id=486fc6cf"
import script from "./OrganiserDiscountPrompt.vue?vue&type=script&lang=js"
export * from "./OrganiserDiscountPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports